<template>
  <div class="ctrl-wrap">
    <div class="wrapper">
      <Select placeholder="Output type" prop="imageDimension">
        <optgroup label="Image">
          <option value="img-1920x1920">Square image</option>
          <option value="img-1080x1920">Portrait image</option>
          <option value="img-1920x1080">Landscape image</option>
        </optgroup>
        <optgroup label="Video">
          <option value="vid-1920x1920">Square video</option>
          <option value="vid-1080x1920">Portrait video</option>
          <option value="vid-1920x1080">Landscape video</option>
        </optgroup>
      </Select>
    </div>
    <div class="wrapper">
      <div class="loader-wrap" ref="loader">
        <Select
          placeholder="Video duration"
          prop="videoDuration"
          :disabled="!exportVideo"
        >
          <option value="2000">2s</option>
          <option value="5000">5s</option>
          <option value="10000">10s</option>
          <option value="15000">15s</option>
        </Select>
      </div>
      <Button :action="download" />
    </div>
  </div>
</template>

<script>
import Button from "@/components/ui/Button";
import Select from "@/components/ui/Select";
import { store } from "@/store/scene.js";
export default {
  name: "Downloader",
  data() {
    return {
      chunks: [],
    };
  },
  components: {
    Button,
    Select,
  },
  computed: {
    exportVideo() {
      return store.imageDimension.split("-")[0] === "vid";
    },
  },
  methods: {
    download() {
      return this.exportVideo ? this.downloadVideo() : this.downloadImg();
    },
    downloadImg() {
      if (store.rounded) {
        const sourceImageData = store.canvas.toDataURL("image/png");
        const destCanvasContext = store.canvasCopy.getContext("2d");

        let destinationImage = new Image();
        destinationImage.onload = function () {
          destCanvasContext.save();
          destCanvasContext.roundRect(
            0,
            0,
            store.canvasCopy.width,
            store.canvasCopy.height,
            [0, 0, 120, 0]
          );
          destCanvasContext.clip();
          destCanvasContext.drawImage(destinationImage, 0, 0);
          destCanvasContext.restore();

          setTimeout(
            store.canvasCopy.toBlob((blob) => {
              saveBlob(
                blob,
                `screencapture-${store.canvasCopy.width}x${store.canvasCopy.height}.png`
              );
            }),
            1500
          );
        };
        destinationImage.src = sourceImageData;
      } else {
        setTimeout(
          store.canvas.toBlob((blob) => {
            saveBlob(
              blob,
              `screencapture-${store.canvas.width}x${store.canvas.height}.png`
            );
          }),
          1500
        );
      }

      const saveBlob = (function () {
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        return function saveData(blob, fileName) {
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = fileName;
          a.click();
        };
      })();
    },
    downloadVideo() {
      this.chunks = [];
      const canvas_stream = store.canvas.captureStream(60);
      // Create media recorder from canvas stream
      const media_recorder = new MediaRecorder(canvas_stream, {
        mimeType: "video/webm; codecs=vp9",
      });
      // Record data in chunks array when data is available
      media_recorder.ondataavailable = (evt) => {
        this.chunks.push(evt.data);
      };
      // Provide recorded data when recording stops
      media_recorder.onstop = () => {
        // Gather chunks of video data into a blob and create an object URL
        const blob = new Blob(this.chunks, { type: "video/webm" });
        const recording_url = URL.createObjectURL(blob);
        // Attach the object URL to an <a> element, setting the download file name
        const a = document.createElement("a");
        a.style = "display: none;";
        a.href = recording_url;
        a.download = "video.webm";
        document.body.appendChild(a);
        // Trigger the file download
        a.click();
        setTimeout(() => {
          // Clean up - see https://stackoverflow.com/a/48968694 for why it is in a timeout
          URL.revokeObjectURL(recording_url);
          document.body.removeChild(a);
        }, 0);
      };
      const loader = this.$refs.loader;
      loader.style.transitionDuration = `${+store.videoDuration}ms`;
      loader.classList.add("loaded");
      // Start recording using a 1s timeslice [ie data is made available every 1s)
      media_recorder.start(1000);
      setTimeout(() => {
        media_recorder.stop();
        loader.classList.remove("loaded");
      }, +store.videoDuration + 1000); // millis
    },
  },
};
</script>

<style scoped>
.ctrl-wrap > *:not(:last-child) {
  margin-right: 1.5rem;
}
.wrapper {
  display: flex;
  align-items: center;
}
.wrapper > *:last-child {
  margin-left: 1.5rem;
}
.loader-wrap {
  position: relative;
}
.loader-wrap:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 100%;
  background-color: #5a5ccd;
  position: absolute;
  top: 0;
  transform-origin: left;
  transform: scaleX(0);
  transition-property: transform 0.3s ease;
  will-change: transform;
}
.loader-wrap.loaded:after {
  transform: scaleX(1);
  transition-duration: inherit;
}
</style>